import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { ICheckboxOption } from './ICheckboxOption';

@Component({
    selector: 'multi-checkbox',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [options]="fieldConfig"
                    [attr.class]="fieldConfig.className">
            <multi-checkbox-field [formControlName]="fieldConfig.formControlName"
                                  [selectAllWhenEmpty]="selectAllWhenEmpty"
                                  [options]="options"
                                  [isRadio]="isRadio"
                                  [allowSelectAllBehaviour]="allowSelectAllBehaviour"
                                  [preSelectedValue]="preSelectedValue"
                                  [showLabel]="showLabel"
                                  (onChange)="onChange.emit($event)">
            </multi-checkbox-field>
        </form-field>
    `,
    styles: [`
    `],
})
export class MultiCheckboxComponent {

    @Input()
    public selectAllWhenEmpty: boolean = true;

    @Input()
    public allowSelectAllBehaviour: boolean = true;

    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public options: ICheckboxOption[];

    @Input()
    public showLabel: boolean = true;

    @Input()
    public isRadio: boolean = false;

    @Input()
    public preSelectedValue: string[];


    @Output()
    public readonly onChange: EventEmitter<string[]> = new EventEmitter();

}
